import { Text, View } from '@react-pdf/renderer'

import { SalesReportPdfStatisticsItem } from '../../../../../../types/salesReportPdfStatisticsItem'
import { pdfStyles } from './utils/pdfStyles'

export const SalesReportPdfStatisticsCardColumn = ({ label, value }: SalesReportPdfStatisticsItem) => {
  return (
    <View style={pdfStyles.column}>
      <Text style={pdfStyles.label}>{label}</Text>
      <Text style={pdfStyles.heading}>{value}</Text>
    </View>
  )
}
